import React, { ChangeEvent } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, CardActions, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import TextField from '@mui/material/TextField';
import './UserDetails.scss';
import { UserForm, AuthTypes } from './types';

export default function UserDetails({
    user,
    onChangeInput,
    onChangeBooleanSelection,
    formErrors,
}: {
    user: UserForm;
    isEditUserPending: boolean;
    onChangeInput: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    onChangeBooleanSelection: (e: SelectChangeEvent<AuthTypes>) => void;
    formErrors: Partial<UserForm>;
}) {
    return (
        <>
            <Box id="user-details-container">
                <CardActions>
                    <Grid container spacing={2} justifyContent="center" margin="2rem 0">
                        <Grid xs={12} sm={8}>
                            <FormControl fullWidth>
                                <TextField
                                    disabled
                                    id="email"
                                    name="email"
                                    label="Username/Email"
                                    fullWidth
                                    variant="outlined"
                                    value={user.email ? user.email : ''}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={12} sm={8}>
                            <FormControl fullWidth>
                                <TextField
                                    error={!!formErrors.firstName}
                                    helperText={formErrors.firstName}
                                    required
                                    id="firstName"
                                    name="firstName"
                                    label="First name"
                                    fullWidth
                                    variant="outlined"
                                    value={user.firstName ? user.firstName : ''}
                                    onChange={onChangeInput}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={12} sm={8}>
                            <FormControl fullWidth>
                                <TextField
                                    error={!!formErrors.lastName}
                                    helperText={formErrors.lastName}
                                    required
                                    id="lastName"
                                    name="lastName"
                                    label="Last Name"
                                    fullWidth
                                    variant="outlined"
                                    value={user.lastName ? user.lastName : ''}
                                    onChange={onChangeInput}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={12} sm={8}>
                            <FormControl fullWidth>
                                <InputLabel id="federated-select-label">Authentication</InputLabel>
                                <Select
                                    labelId="federated-select-label"
                                    label="Authentication"
                                    required
                                    error={!!formErrors.isFederated}
                                    id="isFederated"
                                    name="isFederated"
                                    fullWidth
                                    variant="outlined"
                                    value={user.isFederated ? AuthTypes.External : AuthTypes.Internal}
                                    onChange={onChangeBooleanSelection}
                                >
                                    <MenuItem value={AuthTypes.Internal}>Internal FMTP</MenuItem>
                                    <MenuItem value={AuthTypes.External}>External Microsoft Entra</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardActions>
            </Box>
        </>
    );
}
